import Subheading, { SubheadingColourScheme } from "components/Subheading";

interface IRafflePrizeCardProps {
  heading: string;
  subheading?: string;
  backgroundImage: string;
  onClick?: () => void;
  style: React.CSSProperties;
}

const RafflePrizeCard = ({
  heading,
  subheading,
  backgroundImage,
  onClick,
  style,
}: IRafflePrizeCardProps) => {
  return (
    <div className="rafflePrizeCard" onClick={onClick} style={style}>
      {onClick && (
        <h2
          style={{
            fontWeight: "normal",
            fontSize: "30px",
            position: "absolute",
            top: 0,
            right: 0,
          }}
        >
          +
        </h2>
      )}

      <Subheading
        Tag="h4"
        className="rafflePrizeCardTitle"
        colourScheme={SubheadingColourScheme.WHITE_TEXT_BLACK_SHADOW}
      >
        {heading}
      </Subheading>

      <p>{subheading}</p>

      <style jsx>{`
        .rafflePrizeCard {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: white;
          text-align: center;
          width: 100%;
          height: 180px;
          background-color: gray;
          margin: 6px;
          border-radius: 4px;
          box-shadow: 0 0 5px gray, inset 0 0 0 1000px rgba(0, 0, 0, 0.45);
          overflow: visible;
          background-image: ${backgroundImage};
          background-size: cover;
          background-position: center;
          padding: 1.5em;
          cursor: ${onClick ? "pointer" : "default"};
        }

        :global(.subheading.rafflePrizeCardTitle) {
          font-size: 1.5rem;
        }

        @media (min-width: 410px) {
          .rafflePrizeCard {
            height: 280px;
          }
        }

        .rafflePrizeCard h5 {
          font-size: 1.4em;
          color: white;
          font-weight: bold;
          margin-bottom: 2px;
        }

        .rafflePrizeCard p {
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default RafflePrizeCard;
